import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from './../../shared/global.service';
import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { AlertService } from '../../shared/services/alert.service';
import { UrlService } from '../../shared/services/url.service';
import { UrlControl } from '../../shared/models/generic.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { Accesibilidad } from 'src/app/models/acceibilidad.model';
declare var $: any;
@Component({
  selector: 'app-rol',
  templateUrl: './rol.component.html',
  styleUrls: ['./rol.component.scss']
})
export class RolComponent implements OnInit, AfterViewChecked {
  seleccionRol = false;
  roles: any[];
  parametros: string[] = [DominiosService.PARAMETRO_URL_FTP];
  parametroTiempo: string[] = [DominiosService.PARAMETRO_TIEMPO_SESSION_ACCESIBILIDAD];
  iconImage: any = undefined;
  tipoDocumentoUsuario: string;
  numeroDocumentoUsuario: string;
  listadoTipoDocumento: any[];
  existeSIA3 = true;
  tieneAdministrador = false;
  tieneAdministradorUAC = false;
  tienePreautorizador = false;
  tienePOI = false;
  tieneVigilante = false;
  tieneVentanilla = false;
  tieneTH = false;
  tieneSGA = false;
  tieneTecnologia = false;
  tieneFuncionario = false;
  rolAdministrador = DominiosService.ROL_ADMINISTADOR;
  textoAdministrador = 'Administrador ACVIS';
  rolPreautorizador = DominiosService.ROL_PREAUTORIZADOR;
  textoPreautorizador = 'Preautorizador';
  rolVigilante = DominiosService.ROL_VIGILANTE;
  textoVigilante = 'Vigilante';
  rolAdministradorUAC = DominiosService.ROL_ADMINISTADOR_UAC;
  textoAdministradorUAC = 'Administrador UAC';
  rolPOI = DominiosService.ROL_POI;
  textoPOI = 'POI';
  rolVentanilla = DominiosService.ROL_VENTANILLA;
  textoVentanilla = 'Ventanilla';
  rolTH = DominiosService.ROL_ADMINISTRADOR_TH;
  textoTH = 'Administrador Talento Humano';
  rolSGA = DominiosService.ROL_ADMINISTRADOR_SGA;
  textoSGA = 'Administrador SGA';
  rolTecnologia = DominiosService.ROL_ADMINISTRADOR_TEC;
  textoTecnologia = 'Administrador de Tecnología';

  rolFuncionario = DominiosService.ROL_FUNCIONARIO;
  textoFuncionario = 'Funcionario';

  accesibilidadUsuario: Accesibilidad = new Accesibilidad();


  isPasaporte = false;

  constructor(
    public global: GlobalService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private urlService: UrlService,
    private util: UtilService
  ) {
    this.tipoDocumentoUsuario = null;
    this.global.setThemeInit();
    this.iconImage = this.global.icon;
  }

  ngOnInit() {
    if (sessionStorage.getItem('Token')) {
      this.getTipoIdentificacion();
      //---accesibilidad
      this.consultarParametrosAccesibilidad();
      this.roles = this.global.usuario.roles;
      this.consultarUsuarioSession();
      setTimeout(() => {
        this.consultarParametroFTP();
        this.consultarParametroTiempoGurdadoAcecibilidad();
      }, 1000);
      this.consultarParametroPorDefecto();
      if (this.roles.length > 1) {
        this.seleccionRol = true;
        // cambiar para entrega
        /*
        this.tieneAdministrador = true;
        this.tieneAdministradorUAC = true;
        this.tienePreautorizador = true;
        this.tienePOI = true;
        this.tieneVigilante = true;
        this.tieneVentanilla = true;
        this.tieneTH = true;
        this.tieneSGA = true;
        this.tieneTecnologia = true;
        this.tieneFuncionario = true;
        */

        this.tieneAdministrador = this.roles.includes(this.textoAdministrador);
        this.tieneAdministradorUAC = this.roles.includes(this.textoAdministradorUAC);
        this.tienePreautorizador = this.roles.includes(this.textoPreautorizador);
        this.tienePOI = this.roles.includes(this.textoPOI);
        this.tieneVigilante = this.roles.includes(this.textoVigilante);
        this.tieneVentanilla = this.roles.includes(this.textoVentanilla);
        this.tieneTH = this.roles.includes(this.textoTH);
        this.tieneSGA = this.roles.includes(this.textoSGA);
        this.tieneTecnologia = this.roles.includes(this.textoTecnologia);
        this.tieneFuncionario = this.roles.includes(this.textoFuncionario);

      }
    }
  }

  ngAfterViewChecked() {
    const img = $('#image');
    if (!img.attr('src')) {
      img.attr('src', this.global.icon);
    }
  }

  validarTipoDocumento() {
    if (this.tipoDocumentoUsuario === DominiosService.TIPO_DOCUMENTO_PASAPORTE
      || this.tipoDocumentoUsuario === DominiosService.TIPO_DOCUMENTO_EXTRANJERIA) {
      this.isPasaporte = true;
    } else {
      this.isPasaporte = false;
    }
    this.numeroDocumentoUsuario = undefined;
  }

  /**
   * obtiene el dominio tipo identificacion
   * jvillalobos
   */
  public getTipoIdentificacion() {
    const serviceProvider = 'getTipoIdentificacion';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
    this.global.getGenerico(url).subscribe(
      data => {
        this.listadoTipoDocumento = data;
      }, err => {
        this.alertService.generateAlertError('Error consultando los tipos de documento', '');
      }
    );
  }

  validarCampos() {
    return this.util.validarCamposObligatorios(this.tipoDocumentoUsuario)
      && this.util.validarCamposObligatorios(this.numeroDocumentoUsuario);
  }

  goToRol(rol, rolSia3) {
    if (!this.existeSIA3) {
      this.consultarFuncionario(rol, rolSia3);
    } else {
      this.ingresar(rol, rolSia3);
    }
  }

  ingresar(rol: any, rolSia3: string) {
    this.global.rolSeleccionado = rolSia3;
    sessionStorage.setItem(ConstantesService.ROL_SESSION, rol);
    sessionStorage.setItem(ConstantesService.ROL_SESSION_SIA3, rolSia3);
    this.global.permisosUsuario = [];
    this.obtenerPermisos(this.global.usuario.permisos);

    switch (rol) {
      case this.rolVentanilla:
        this.router.navigate(['/main/atender-ciudadano-UAC']);
        break;
      case this.rolPOI:
        this.router.navigate(['/main/registro-ciudadano-UAC']);
        break;
      case this.rolAdministradorUAC:
        this.router.navigate(['/main/generar-reporte-UAC']);
        break;
      case this.rolTH:
      case this.rolSGA:
      case this.rolTecnologia:
        this.router.navigate(['/main/administrar-funcionarios']);
        break;
      case this.rolFuncionario:
        this.router.navigate(['/main/plan-compensatorio/solicitud-ajuste-compensacion']);
        break;
      default:
        this.router.navigate(['/main/']);
        break;
    }
  }

  obtenerPermisos(permisos) {
    permisos.forEach(element => {
      if (element.nombreRolAsociado === this.global.rolSeleccionado) {
        this.global.permisosUsuario.push(element);
      }
      if (element.hijosOpcion && element.hijosOpcion.length > 0) {
        this.obtenerPermisos(element.hijosOpcion);
      }
    });
  }

  ingresoRolUnico() {
    let rol = this.rolAdministrador;
    let rolSia3 = this.textoAdministrador;
    if (this.roles.includes(this.textoPreautorizador)) {
      rol = this.rolPreautorizador;
      rolSia3 = this.textoPreautorizador;
    } else if (this.roles.includes(this.textoVigilante)) {
      rol = this.rolVigilante;
      rolSia3 = this.textoVigilante;
    } else if (this.roles.includes(this.textoPOI)) {
      rol = this.rolPOI;
      rolSia3 = this.textoPOI;
    } else if (this.roles.includes(this.textoAdministradorUAC)) {
      rol = this.rolAdministradorUAC;
      rolSia3 = this.textoAdministradorUAC;
    } else if (this.roles.includes(this.textoVentanilla)) {
      rol = this.rolVentanilla;
      rolSia3 = this.textoVentanilla;
    } else if (this.roles.includes(this.textoTH)) {
      rol = this.rolTH;
      rolSia3 = this.textoTH;
    } else if (this.roles.includes(this.textoSGA)) {
      rol = this.rolSGA;
      rolSia3 = this.textoSGA;
    } else if (this.roles.includes(this.textoTecnologia)) {
      rol = this.rolTecnologia;
      rolSia3 = this.textoTecnologia;
    }
    this.goToRol(rol, rolSia3);
  }

  private consultarUsuarioSession() {
    const serviceProvider = 'consultarFucionarioSIA3';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['idSia3', sessionStorage.getItem(ConstantesService.SIA3_SESSSION)]);
    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
    this.global.getGenerico(url).subscribe(
      data => {
        this.setVariablesSession(data);
        this.tipoDocumentoUsuario = data.tipoIdFuncionario;
        this.numeroDocumentoUsuario = data.numeroIdFuncionario;
        sessionStorage.setItem(ConstantesService.NOMBRE_SESSION, data.nombreCompleto);
        this.global.usuario.nombre = data.nombreCompleto;
        if (this.roles.length === 1) {
          this.ingresoRolUnico();
        }
      }, err => {
        this.existeSIA3 = false;
        this.alertService.generateAlertError('El usuario SIA3 no se encuentra asociado a un funcionario', 'Error');
      }
    );
  }

  private setVariablesSession(data: any) {
    sessionStorage.setItem('Usuario', JSON.stringify(this.global.usuario));
    sessionStorage.setItem(ConstantesService.TIPO_DOC_SESSSION, data.tipoIdFuncionario);
    sessionStorage.setItem(ConstantesService.NUM_DOC_SESSSION, data.numeroIdFuncionario);
    sessionStorage.setItem(ConstantesService.SEDE_SESSSION, data.sede);
    sessionStorage.setItem(ConstantesService.SIA3_SESSSION, this.global.usuario.userid);

  }

  private consultarParametroFTP() {
    const serviceProvider = 'consultarParametros';
    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
    this.global.postGenerico(url, this.parametros).subscribe(
      data => {
        if (data.length > 0) {
          sessionStorage.setItem(ConstantesService.FTP_SESSSION, data[0].valor);
        } else {
          this.alertService.generateAlertError('Ocurrio un error en la consulta del servidor de imagenes', 'Error');
        }

      }, err => {
        this.alertService.generateAlertError('Ocurrio un error en la consulta del servidor de imagenes', 'Error');
      }
    );
  }

  private consultarParametroTiempoGurdadoAcecibilidad() {
    const serviceProvider = 'consultarParametros';
    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
    this.global.postGenerico(url, this.parametroTiempo).subscribe(
      data => {
        if (data.length > 0) {
          sessionStorage.setItem(ConstantesService.TIEMPO_ACCESIBILIDAD_SESSION, data[0].valor);
        } else {
          sessionStorage.setItem(ConstantesService.TIEMPO_ACCESIBILIDAD_SESSION, ConstantesService.ACCESIBILIDAD_TIEMPO_GUARDADO_DEFECTO);
        }

      }, err => {
        sessionStorage.setItem(ConstantesService.TIEMPO_ACCESIBILIDAD_SESSION, ConstantesService.ACCESIBILIDAD_TIEMPO_GUARDADO_DEFECTO);
      }
    );
  }

  private consultarFuncionario(rol, rolSia3) {
    const serviceProvider = 'asociarFuncionario';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['tipoDocumento', this.tipoDocumentoUsuario]);
    queryParams.push(['numeroDocumento', this.numeroDocumentoUsuario]);
    queryParams.push(['idSia3', sessionStorage.getItem(ConstantesService.SIA3_SESSSION)]);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);

    this.global.get(url).subscribe(
      data => {
        sessionStorage.setItem(ConstantesService.NOMBRE_SESSION, data);
        this.setVariablesSession({
          tipoIdFuncionario: this.tipoDocumentoUsuario
          , numeroIdFuncionario: this.numeroDocumentoUsuario, sede: 'PRI'
        });
        this.global.usuario.nombre = data;
        this.ingresar(rol, rolSia3);
      }, err => {
        if (err.error) {
          this.alertService.generateAlertError(JSON.parse(err.error).message, 'Error');
        } else {
          this.alertService.generateAlertError('Se presentó un error al asociar el funcionario', 'Error');
        }
      }
    );

  }

  /**
   * Método que consulta la sede por defecto
   */
  public consultarParametroPorDefecto() {
    this.spinner.show();
    const serviceProvider = 'consultarParametros';
    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
    this.global.postGenerico(url, [DominiosService.SEDE_POR_DEFECTO]).subscribe(
      data => {
        if (data.length > 0) {
          sessionStorage.setItem(ConstantesService.SEDE_DEFECTO_SESSSION, data[0].valor);
          this.spinner.hide();
        } else {
          this.alertService.generateAlertError('Ocurrio un error consultando el parametro por defecto de la sede', 'Error');
          this.spinner.hide();
        }
      }, err => {
        this.alertService.generateAlertError('Ocurrio un error consultando el parametro por defecto de la sede', 'Error');
        this.spinner.hide();
      }
    );
  }

  //parametros de accesibilidad

  public consultarParametrosAccesibilidad() {
    this.spinner.show();
    const serviceProvider = 'ConsultarParametrosAccesibilidad';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['user_id', sessionStorage.getItem(ConstantesService.SIA3_SESSSION)]);
    let url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), sessionStorage.getItem('urlBase'));
    // url = 'http://sia3rcert.mineducacion.gov.co/seguridad-apiRest-pub/recursoswebseguridad/accesibilidad/propiedadesAccUser/obtenerPropAccesibilidad?user_id=2';  
    this.global.getSIA3Seguro(url).subscribe(
      data => {
        if (data && data.accesibilidad) {
          this.accesibilidadUsuario = data.accesibilidad;
          this.procesarParametrosAccesibilidad();
        }
        this.spinner.hide();
      }, (err: any) => {
        // this.cathException('Ocurrio un error en la consulta de los dominios');
        //this.procesarParametrosAccesibilidad();

        //Debido a un error de cors contra sia3 prod se ve obligado a forzar el cargue de los parámetros por defecto para la accesibilidad
        const json = { "contrasteDefault": "1", "tamanioLetra": "125", "tiempoMensajes": "5000", "lenguajeSenias": "false", "tecladoVirtual": "false", "tiempoReversibilidad": "3000", "lenguajeSeniasBoolean": false, "tecladoVirtualBoolean": false, "tamanioLetraNumber": 125, "tiempoMensajesNumber": 5000, "contrasteTema": "yeti" };
        sessionStorage.setItem(ConstantesService.ACCESIBILIDAD_SESSION, JSON.stringify(json));

        this.spinner.hide();

      }
    );
  }

  private procesarParametrosAccesibilidad() {

    this.accesibilidadUsuario.lenguajeSeniasBoolean = (/true/i).test(this.accesibilidadUsuario.lenguajeSenias) ? true
      : ConstantesService.ACCESIBILIDAD_LENGUAJE_DEFECTO;
    this.accesibilidadUsuario.tecladoVirtualBoolean = (/true/i).test(this.accesibilidadUsuario.tecladoVirtual) ? true
      : ConstantesService.ACCESIBILIDAD_TECLADO_DEFECTO;
    this.accesibilidadUsuario.tamanioLetraNumber = (isNaN(parseInt(this.accesibilidadUsuario.tamanioLetra, 10))
      || parseInt(this.accesibilidadUsuario.tamanioLetra, 10) < 100
      || parseInt(this.accesibilidadUsuario.tamanioLetra, 10) > 150) ?
      ConstantesService.ACCESIBILIDAD_TAMANIO_LETRA : parseInt(this.accesibilidadUsuario.tamanioLetra, 10);
    this.accesibilidadUsuario.tiempoMensajesNumber = (!isNaN(parseFloat(this.accesibilidadUsuario.tiempoMensajes))
      || parseFloat(this.accesibilidadUsuario.tiempoMensajes) > 100) ? parseFloat(this.accesibilidadUsuario.tiempoMensajes)
      : ConstantesService.ACCESIBILIDAD_TIEMPO_MENSAJE;
    this.accesibilidadUsuario.contrasteTema = this.validarTema(this.accesibilidadUsuario.contrasteDefault);
    sessionStorage.setItem(ConstantesService.ACCESIBILIDAD_SESSION, JSON.stringify(this.accesibilidadUsuario));

  }


  validarTema(theme) {
    let temaContraste = 'yeti';
    switch (theme) {
      case '2':
        temaContraste = 'dark-white';
        break;
      case '3':
        temaContraste = 'rosa-fucsia';
        break;
      case '4':
        temaContraste = 'gris-blanco';
        break;
    }
    return temaContraste;
  }
}
